module.exports = __webpack_public_path__ + "img/background016.jpg";